// ROOT SWITCH (Founder 19/10/26: "אני רוצה לבטל את השאלונים"). true = every questionnaire entry point is OFF
// (article inline quiz, the global QuickConsult bar + its hidden wizard, category/pro intake cards, topic quiz).
// Pro cards, הודעה/התקשר, the ct2 dock "ייעוץ" (direct WhatsApp door /wa/consult), city chooser, prices and SEO stay.
// Logging code, DB tables and admin pages are untouched. Flip to false + deploy to bring the questionnaires back.
export const QUESTIONNAIRES_OFF = true;
